export const AgentIcon: React.FC<any> = ({ className }) => {
  return (
    <div
      className={className}
      dangerouslySetInnerHTML={{
        __html: `
        <svg xmlns="http://www.w3.org/2000/svg" width="30" height="29" viewBox="0 0 30 29" fill="inherit">
        <g clip-path="url(#clip0_2594_8622)">
            <path d="M15.0306 14.6848C18.9228 14.6848 22.0881 11.5195 22.0881 7.62733C22.0881 3.73511 18.9228 0.569824 15.0306 0.569824C11.1384 0.569824 7.97309 3.73511 7.97309 7.62733C7.97309 11.5195 11.1384 14.6848 15.0306 14.6848ZM15.0306 2.92233C17.6254 2.92233 19.7356 5.03252 19.7356 7.62733C19.7356 10.2221 17.6254 12.3323 15.0306 12.3323C12.4358 12.3323 10.3256 10.2221 10.3256 7.62733C10.3256 5.03252 12.4358 2.92233 15.0306 2.92233ZM25.6168 27.6236C25.6168 28.2729 25.0911 28.7998 24.4406 28.7998C23.7901 28.7998 23.2643 28.2729 23.2643 27.6236C23.2643 24.0725 21.0001 21.0483 17.843 19.8956L16.0586 22.5728L17.3443 27.266C17.5595 28.0494 16.8679 28.801 15.9316 28.801H14.1296C13.1933 28.801 12.5028 28.0494 12.7169 27.266L14.0025 22.5728L12.2182 19.8956C9.06112 21.0483 6.79684 24.0725 6.79684 27.6248C6.79684 28.2741 6.26988 28.801 5.62059 28.801C4.9713 28.801 4.44434 28.2741 4.44434 27.6248C4.44434 21.7882 9.19404 17.0385 15.0306 17.0385C20.8671 17.0385 25.6168 21.787 25.6168 27.6236Z" fill="inherit"/>
        </g>
        <defs>
            <clipPath id="clip0_2594_8622">
            <rect width="28.23" height="28.23" fill="white" transform="translate(0.915527 0.569824)"/>
            </clipPath>
        </defs>
        </svg>
    `,
      }}
    />
  );
};
